import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted, ref } from 'vue'

import AffiliateProgress from './AffiliateProgress.vue'
import PortalProgress from './PortalProgress.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
    isPortal: { type: Boolean }
  },
  setup(__props: any) {



const progress = ref(0)

const imageWidth = computed(() => (__props.isPortal ? 229 : 276))
const fillWidth = computed(() => (imageWidth.value * progress.value) / 100)

const customEaseIn = (t: number) => {
    if (t <= 0.7) {
        const normalizedT = t / 0.7
        return normalizedT * normalizedT * normalizedT * 0.4
    } else {
        const normalizedT = (t - 0.7) / 0.3
        return 0.4 + (1 - Math.pow(1 - normalizedT, 5)) * 0.6
    }
}

onMounted(() => {
    {
        progress.value = 0
        const startTime = Date.now()
        const duration = 2000 // Duration in milliseconds (1.8 seconds)

        const animate = () => {
            const elapsed = Date.now() - startTime
            const linearProgress = Math.min(elapsed / duration, 1)

            const easedProgress = customEaseIn(linearProgress)
            progress.value = easedProgress * 100

            if (linearProgress < 1) {
                requestAnimationFrame(animate)
            }
        }

        requestAnimationFrame(animate)
    }
})

return (_ctx: any,_cache: any) => {
  return (_ctx.isPortal)
    ? (_openBlock(), _createBlock(PortalProgress, {
        key: 0,
        fillWidth: fillWidth.value
      }, null, 8, ["fillWidth"]))
    : (_openBlock(), _createBlock(AffiliateProgress, {
        key: 1,
        fillWidth: fillWidth.value
      }, null, 8, ["fillWidth"]))
}
}

})